import { computed } from 'vue';
import { useMobile } from '@/composables/useMobile';

// Check is mobile
/**
 * @deprecated
 */
const isMobile = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent || navigator.vendor
    );

const MOBILE_PLACEHOLDER_WIDTH_PORTRAIT =
    import.meta.env.VITE_MOBILE_PLACEHOLDER_WIDTH_PORTRAIT || 480;
const MOBILE_PLACEHOLDER_WIDTH_LANDSCAPE =
    import.meta.env.VITE_MOBILE_PLACEHOLDER_WIDTH_LANDSCAPE || 768;

const useMobileByScreenSize = () => {
    const { isMobile: portrait } = useMobile(
        `only screen and (orientation: portrait) and (max-width: ${MOBILE_PLACEHOLDER_WIDTH_PORTRAIT}px)`
    );
    const { isMobile: landscape } = useMobile(
        `only screen and (orientation: landscape) and (max-width: ${MOBILE_PLACEHOLDER_WIDTH_LANDSCAPE}px)`
    );
    const isMobile = computed(() => portrait.value || landscape.value);
    return { isMobile };
};
export { isMobile, useMobileByScreenSize };
export default { isMobile, useMobileByScreenSize };
